import { createSlice } from "@reduxjs/toolkit";
import { PartState } from "../../utils/types/types";

const initialState: PartState = {
    partName: "",
    partId: "",
};

export const partSlice = createSlice({
  name: "part",
  initialState,
  reducers: {
    selectPart: (state, action) => {
      state = action.payload;
      return state;
    },
    getPartDetails: (state) => {
        return state;
    }
  },
});

export const { selectPart, getPartDetails } = partSlice.actions;

export default partSlice.reducer;
